<h3 mat-dialog-title>
    <span *ngIf="data.account.linkedBankAccount.pullsTransactions">Disable</span>
    <span *ngIf="!data.account.linkedBankAccount.pullsTransactions">Enable</span>
    Transactions for {{data.account.friendlyName}}?
</h3>

<mat-dialog-content>
    <p *ngIf="data.account.linkedBankAccount.pullsTransactions">
        Disabling transaction synchronization will halt the import process from your bank ledger
        into PayHOA's accounting system. You can re-enable this setting at any time.
    </p>
    <ng-container *ngIf="!data.account.linkedBankAccount.pullsTransactions">
        <p>
            Enabling transaction synchronization will allow new transactions from your bank ledger
            to be imported automatically into PayHOA's accounting system.
        </p>
        <p>
            Imports are attempted daily. Transactions must not be pending,
            resulting in a delay of up to several days between some entries appearing in your
            banking platform and being imported by PayHOA.
        </p>
    </ng-container>
    <p>Are you sure that you wish to continue?</p>
</mat-dialog-content>

<mat-dialog-actions>
    <button (click)="closeDialog()" [disabled]="isToggleInFlight" class="btn btn-outline-secondary">
        No, Keep Current Setting
    </button>
    <button (click)="toggleTransactions()"
            [disabled]="isToggleInFlight"
            class="btn btn-primary">
        Yes, <span *ngIf="data.account.linkedBankAccount.pullsTransactions">Disable Transactions</span><span
        *ngIf="!data.account.linkedBankAccount.pullsTransactions">Enable Transactions</span>
    </button>
</mat-dialog-actions>
